import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Home, ArrowLeft, Search } from "lucide-react";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { api } from "@/lib/api";

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const [contactEmail, setContactEmail] = useState("zca.k.12.26@outlook.com");
  useEffect(() => {
    api.get("/settings")
      .then((r) => { if (r.data?.contact_email) setContactEmail(r.data.contact_email); })
      .catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SiteHeader />
      <section className="flex-1 max-w-2xl w-full mx-auto px-5 py-24 text-center">
        <div className="text-xs tracking-[0.22em] uppercase text-gold font-bold mb-6">
          404 · Page not found
        </div>
        <div className="h-serif text-purple-dark text-7xl sm:text-8xl tracking-tight mb-4">
          Lost your way?
        </div>
        <p className="text-base text-ink/75 leading-relaxed mb-2 max-w-lg mx-auto">
          We couldn&apos;t find the page you&apos;re looking for. It may have moved, been renamed, or never existed at all.
        </p>
        <div className="inline-flex items-center gap-2 bg-grey-light border border-grey px-4 py-1.5 mt-4 mb-10 text-xs text-ink/60 font-mono" data-testid="notfound-path">
          <Search size={12} /> {pathname}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-purple text-white hover:bg-purple-dark font-bold px-6 py-3 rounded-sm text-sm"
            data-testid="notfound-home-btn"
          >
            <Home size={14} /> Return home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 border border-purple text-purple hover:bg-grey-light font-bold px-6 py-3 rounded-sm text-sm"
            data-testid="notfound-back-btn"
          >
            <ArrowLeft size={14} /> Go back
          </button>
        </div>
        <div className="mt-16 pt-8 border-t border-grey text-xs text-ink/60">
          Looking for something specific?{" "}
          <Link to="/#faq" className="text-purple hover:text-purple-dark font-bold">FAQ</Link>
          {" · "}
          <Link to="/portal/login" className="text-purple hover:text-purple-dark font-bold">Parent Portal</Link>
          {" · "}
          <a href={`mailto:${contactEmail}`} className="text-purple hover:text-purple-dark font-bold">Email the school</a>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
